import React from 'react';

interface CircleVoiceBlockProps {
  // Add props as needed
  className?: string;
}

export const CircleVoiceBlock: React.FC<CircleVoiceBlockProps> = () => {
  return (
    <div className={`widget-speaking w-[120px] h-[120px] rounded-[50%] flex items-center justify-center p-[1px]`}>
          <div className={`widget-content bg-white [cursor:pointer] w-[100%] h-[100%] rounded-[50%] flex items-center justify-center gap-[5px]`}>
            <span className="w-[2.8px] h-[4.7px] transition-opacity duration-1000 animate-pulse"></span>
            <span className="w-[2.8px] h-[23.3px] transition-opacity duration-1000 animate-pulse"></span>
            <span className="w-[3px] h-[42px]  transition-opacity duration-1000 animate-pulse"></span>
            <span className="w-[2.8px] h-[28px]  transition-opacity duration-1000 animate-pulse"></span>
            <span className="w-[2.8px] h-[14px]  transition-opacity duration-1000 animate-pulse"></span>
            <span className="w-[2.8px] h-[23.3px]  transition-opacity duration-1000 animate-pulse"></span>
            <span className="w-[2.8px] h-[4.7px] transition-opacity duration-1000 animate-pulse"></span>
          </div>
        </div>
  );
};

export default CircleVoiceBlock; 